import * as PortalConfigSelectors from './lib/+state/portal-config.selectors';

export { SharedDataAccessPortalConfigModule } from './lib/shared-data-access-portal-config.module';
export { PortalConfigSelectors };
